import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearchMinus, faSearchPlus } from "@fortawesome/free-solid-svg-icons";

const widgetProps = {
  "data-brandID": "e1c16095-3e11-4204-b46a-54e78f022676",
  "data-chainID": "6006ab3a-7ba8-436d-99e3-0f1b9b5aa333",
  "data-backgroundprimarycolor": "#6b858b",
  "data-backgroundsecondarycolor": "#6b858b",
  "data-showselectedrate": "false",
  "data-widgetFontColor": "#fff",
  "data-widgetSearchFontColorButton": "#FFFFFF",
  "data-widgetSearchColorButton": "#293839",
  "data-widgetSearchFontColorHoverstate": "#FFFFFF",
  "data-widgetSearchColorHoverState": "#293839",
  id: "rg-booking-widget",
};

export default function BookingWidget() {
  const [isMobile, setIsMobile] = useState(() => window.innerWidth <= 767);
  const [viewBooking, setViewBooking] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 767);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = "https://ibe.rategain.com/widget/index.css";
    document.head.appendChild(link);

    const script = document.createElement("script");
    script.src = "https://ibe.rategain.com/widget/index.js";
    document.body.appendChild(script);

    const handleMessage = (event) => {
      if (event.data === "GET_DLYX") {
        event.source?.postMessage({ dlyx: window.dlyx }, event.origin);
      }
    };
    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
      if (document.head.contains(link)) document.head.removeChild(link);
      if (document.body.contains(script)) document.body.removeChild(script);
    };
  }, []);

  if (isMobile) {
    return createPortal(
      <>
        <div
          onClick={() => setViewBooking((v) => !v)}
          className="btn btn-secondary fixed-booking-button"
        >
          <span className="text-light">
            <FontAwesomeIcon
              icon={viewBooking ? faSearchMinus : faSearchPlus}
              className="me-2"
            />
            {!viewBooking && "Book Now"}
          </span>
        </div>
        <div className="search-form" style={{ display: viewBooking ? "block" : "none" }}>
          <div {...widgetProps} />
        </div>
      </>,
      document.body
    );
  }

  return (
    <div
      className="hero__filter search-form"
      style={{ width: "90%", maxWidth: "1100px", marginLeft: 0 }}
    >
      <div {...widgetProps} />
    </div>
  );
}
